/* import __COLOCATED_TEMPLATE__ from './alert-message.hbs'; */
import { classNames } from '@ember-decorators/component';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';
import styles from './alert-message.module.scss';

@classic
@classNames(styles.component)
export default class ClientAttendanceAlertMessage extends Component {}
